(function () {
  if (window.__pkMostOrderedItemsAtcBound) return;
  window.__pkMostOrderedItemsAtcBound = true;

  var DEFAULT_ITEMS_TO_SHOW = 20;
  var HEAD_COLS = [
    ['product', 'column_product'],
    ['price', 'column_price'],
    ['qty', 'column_quantity'],
    ['action', 'column_add'],
  ];

  var SPINNER_SVG =
    '<svg xmlns="http://www.w3.org/2000/svg" class="spinner" viewBox="0 0 66 66" aria-hidden="true" focusable="false"><circle stroke-width="6" cx="33" cy="33" r="30" fill="none" class="path"></circle></svg>';

  var liveRegionTimer;

  function str(x) {
    return x != null ? String(x) : '';
  }

  function parseJsonEl(el, fallback) {
    if (!el) return fallback;
    try {
      return JSON.parse(el.textContent.trim());
    } catch (e) {
      return fallback;
    }
  }

  function replacePlaceholder(template, token, value) {
    return str(template).split(token).join(str(value));
  }

  function getCartUi() {
    return document.querySelector('cart-notification') || document.querySelector('cart-drawer');
  }

  function appendLabelAndSpinner(btn, label) {
    var span = document.createElement('span');
    span.textContent = str(label);
    btn.appendChild(span);
    var wrap = document.createElement('div');
    wrap.className = 'loading__spinner hidden';
    wrap.setAttribute('aria-hidden', 'true');
    wrap.innerHTML = SPINNER_SVG;
    btn.appendChild(wrap);
  }

  function setSpinnerVisible(btn, visible) {
    var spin = btn && btn.querySelector('.loading__spinner');
    if (spin) spin.classList.toggle('hidden', !visible);
  }

  function setButtonLoading(btn, loading) {
    if (!btn) return;
    btn.classList.toggle('loading', loading);
    btn.disabled = !!loading;
    if (loading) {
      btn.setAttribute('aria-busy', 'true');
    } else {
      btn.removeAttribute('aria-busy');
    }
    setSpinnerVisible(btn, loading);
  }

  function buildFormData(lines) {
    var fd = new FormData();
    var idx = 0;
    var li;
    var line;
    var taxes;
    var ti;
    var t;
    var parentVariantId;
    var qty;

    // Single line without tax: use classic add format so cart-notification gets `key`.
    if (
      lines.length === 1 &&
      !(Array.isArray(lines[0].tax) && lines[0].tax.length)
    ) {
      fd.append('id', str(lines[0].id));
      fd.append('quantity', str(lines[0].quantity));
      if (lines[0].selling_plan) {
        fd.append('selling_plan', str(lines[0].selling_plan));
      }
      return fd;
    }

    for (li = 0; li < lines.length; li++) {
      line = lines[li];
      parentVariantId = str(line.id);
      qty = str(line.quantity);
      fd.append('items[' + idx + '][id]', parentVariantId);
      fd.append('items[' + idx + '][quantity]', qty);
      if (line.selling_plan) {
        fd.append('items[' + idx + '][selling_plan]', str(line.selling_plan));
      }
      taxes = Array.isArray(line.tax) ? line.tax : [];
      if (taxes.length > 0) {
        fd.append(
          'items[' + idx + '][properties][_pk_tax_items]',
          JSON.stringify(
            taxes.map(function (x) {
              return {
                id: str(x.id),
                cost: x.cost != null && x.cost !== '' ? str(x.cost) : '',
              };
            })
          )
        );
        for (ti = 0; ti < taxes.length; ti++) {
          t = taxes[ti];
          idx++;
          fd.append('items[' + idx + '][id]', str(t.id));
          fd.append('items[' + idx + '][quantity]', qty);
          fd.append('items[' + idx + '][parent_id]', parentVariantId);
          if (t.cost != null && t.cost !== '') {
            fd.append('items[' + idx + '][properties][_cost]', str(t.cost));
          }
        }
      }
      idx++;
    }
    return fd;
  }

  function normalizeCartAddResponse(data) {
    if (!data || data.key) return data;
    var first =
      (Array.isArray(data.items) && data.items[0]) ||
      (Array.isArray(data) && data[0]) ||
      null;
    if (!first || !first.key) return data;
    return Object.assign({}, first, {
      sections: data.sections,
      items: data.items || data,
    });
  }

  function cloneLineWithQuantity(line, qty) {
    var out = {
      id: line.id,
      quantity: qty,
    };
    if (line.selling_plan) out.selling_plan = line.selling_plan;
    if (Array.isArray(line.tax) && line.tax.length) out.tax = line.tax;
    return out;
  }

  function readQtyFromRow(row) {
    if (!row) return 1;
    var inp = row.querySelector('input.quantity__input[data-quantity-variant-id]');
    if (!inp) return 1;
    var min = parseInt(inp.getAttribute('min'), 10);
    if (isNaN(min) || min < 1) min = 1;
    var maxAttr = inp.getAttribute('max');
    var maxN = maxAttr != null && maxAttr !== '' ? parseInt(maxAttr, 10) : null;
    if (maxN != null && isNaN(maxN)) maxN = null;
    var step = parseInt(inp.getAttribute('step') || '1', 10) || 1;
    var n = parseInt(inp.value, 10);
    if (isNaN(n) || n < 1) n = min;
    if (n < min) n = min;
    if (maxN != null && n > maxN) n = maxN;
    if (step > 1) {
      var rem = (n - min) % step;
      if (rem !== 0) n -= rem;
      if (n < min) n = min;
    }
    inp.value = str(n);
    return n;
  }

  function flashLiveRegion(sectionEl, message, clearMs, focusLive) {
    var live = sectionEl && sectionEl.querySelector('[data-most-ordered-live-region]');
    if (!live || !message) return;
    live.textContent = '';
    live.textContent = message;
    if (focusLive) {
      if (!live.hasAttribute('tabindex')) live.setAttribute('tabindex', '-1');
      live.focus({ preventScroll: true });
    }
    window.clearTimeout(liveRegionTimer);
    liveRegionTimer = window.setTimeout(function () {
      live.textContent = '';
    }, clearMs || 7000);
  }

  function readItemsToShow(section) {
    var raw = section && section.getAttribute('data-items-to-show');
    var n = parseInt(raw, 10);
    if (isNaN(n) || n < 1) return DEFAULT_ITEMS_TO_SHOW;
    return n;
  }

  function aggregateTopItems(entries, topN) {
    if (!entries.length) return [];

    var map = Object.create(null);
    var i;
    var e;
    var vid;
    var rec;
    var ts;
    var lineQty;
    var out;

    for (i = 0; i < entries.length; i++) {
      e = entries[i];
      vid = str(e.variant_id).trim();
      if (!vid) continue;
      rec = map[vid];
      if (!rec) {
        rec = map[vid] = {
          variant_id: vid,
          total_qty: 0,
          line_count: 0,
          latest_ts: 0,
          display: e,
          cart_line: null,
        };
      }
      lineQty = Number(e.line_quantity);
      if (isNaN(lineQty) || lineQty < 1) lineQty = 1;
      rec.total_qty += lineQty;
      rec.line_count += 1;
      ts = Number(e.order_ts) || 0;
      if (ts >= rec.latest_ts) {
        rec.latest_ts = ts;
        rec.display = e;
      }
      if (e.cart_line && typeof e.cart_line === 'object') {
        rec.cart_line = e.cart_line;
      }
    }

    out = Object.keys(map).map(function (key) {
      return map[key];
    });

    if (!out.length) return [];

    out.sort(function (a, b) {
      if (b.total_qty !== a.total_qty) return b.total_qty - a.total_qty;
      return b.line_count - a.line_count;
    });

    if (out.length <= topN) return out;
    return out.slice(0, topN);
  }

  function buildQtyTemplateMap(bank) {
    var map = Object.create(null);
    var slots;
    var i;
    var vid;
    if (!bank) return map;
    slots = bank.querySelectorAll('template[data-most-ordered-qty-slot]');
    for (i = 0; i < slots.length; i++) {
      vid = str(slots[i].getAttribute('data-variant-id')).trim();
      if (vid) map[vid] = slots[i];
    }
    return map;
  }

  function labeledCol(i18n, suffix, key, text) {
    var div = document.createElement('div');
    div.className = 'buy-again-order-items__grid-col buy-again-order-items__grid-col--' + suffix;
    div.setAttribute('role', 'cell');
    div.setAttribute('data-label', str(i18n[key]));
    if (suffix === 'price' || suffix === 'qty' || suffix === 'action') {
      div.setAttribute('aria-label', str(i18n[key]) + ': ' + str(text));
    }
    div.textContent = str(text);
    return div;
  }

  function renderList(section, items, i18n) {
    var mount = section.querySelector('[data-most-ordered-mount]');
    var bank = section.querySelector('[data-most-ordered-qty-bank]');
    var qtyTemplates = buildQtyTemplateMap(bank);
    if (!mount) return;

    section._moiCartByVariant = Object.create(null);

    mount.innerHTML = '';
    mount.removeAttribute('hidden');
    mount.setAttribute('aria-busy', 'false');

    if (!items.length) {
      var empty = document.createElement('p');
      empty.className = 'buy-again-order-items__message';
      empty.setAttribute('role', 'status');
      empty.textContent = str(i18n.no_items);
      mount.appendChild(empty);
      return;
    }

    var table = document.createElement('div');
    table.className = 'buy-again-order-items__lines most-ordered-items__lines';
    table.setAttribute('role', 'table');
    table.setAttribute('aria-label', str(i18n.list_region));

    var headRow = document.createElement('div');
    headRow.className =
      'buy-again-order-items__grid buy-again-order-items__grid--head buy-again-order-items__grid--head-desktop most-ordered-items__grid--head';
    headRow.setAttribute('role', 'row');
    HEAD_COLS.forEach(function (col) {
      var span = document.createElement('span');
      span.className =
        'buy-again-order-items__grid-col buy-again-order-items__grid-col--' +
        col[0] +
        ' caption-with-letter-spacing';
      span.setAttribute('role', 'columnheader');
      span.setAttribute('scope', 'col');
      span.textContent = str(i18n[col[1]]);
      headRow.appendChild(span);
    });
    table.appendChild(headRow);

    var body = document.createElement('ul');
    body.className = 'buy-again-order-items__line-list list-unstyled most-ordered-items__table-body';
    body.setAttribute('role', 'rowgroup');

    var frag = document.createDocumentFragment();
    var li;
    var item;
    var row;
    var dl;
    var inStock;
    var colProduct;
    var cell;
    var thumb;
    var img;
    var copy;
    var titleSpan;
    var cap;
    var colAction;
    var colQty;
    var tpl;
    var lineBtn;
    var productTitle;
    var variantId;

    for (li = 0; li < items.length; li++) {
      item = items[li];
      dl = item.display || {};
      variantId = str(item.variant_id);
      productTitle = str(dl.title);
      inStock = !!(item.cart_line && typeof item.cart_line === 'object');

      if (inStock) {
        section._moiCartByVariant[variantId] = item.cart_line;
      }

      row = document.createElement('li');
      row.className = 'buy-again-order-items__line-item';
      row.setAttribute('role', 'row');
      row.setAttribute('data-most-ordered-row', '');
      row.setAttribute('data-variant-id', variantId);

      var grid = document.createElement('div');
      grid.className = 'buy-again-order-items__grid buy-again-order-items__grid--line most-ordered-items__grid--line';
      grid.setAttribute('role', 'presentation');

      colProduct = document.createElement('div');
      colProduct.className = 'buy-again-order-items__grid-col buy-again-order-items__grid-col--product';
      colProduct.setAttribute('role', 'cell');
      colProduct.setAttribute('data-label', str(i18n.column_product));

      cell = document.createElement('div');
      cell.className = 'buy-again-order-items__product-cell';

      if (dl.image_url) {
        thumb = document.createElement('div');
        thumb.className = 'buy-again-order-items__thumb';
        img = document.createElement('img');
        img.src = dl.image_url;
        img.alt = productTitle;
        img.loading = 'lazy';
        img.decoding = 'async';
        img.width = 120;
        img.height = 120;
        thumb.appendChild(img);
        cell.appendChild(thumb);
      }

      copy = document.createElement('div');
      copy.className = 'buy-again-order-items__product-copy';
      titleSpan = document.createElement('span');
      titleSpan.className = 'buy-again-order-items__product-title';
      titleSpan.textContent = productTitle;
      copy.appendChild(titleSpan);

      if (dl.variant_title != null && String(dl.variant_title).length > 0) {
        cap = document.createElement('p');
        cap.className = 'caption';
        cap.textContent = String(dl.variant_title);
        copy.appendChild(cap);
      }

      cell.appendChild(copy);
      colProduct.appendChild(cell);
      grid.appendChild(colProduct);

      grid.appendChild(labeledCol(i18n, 'price', 'column_price', dl.price_money));

      colQty = document.createElement('div');
      colQty.className = 'buy-again-order-items__grid-col buy-again-order-items__grid-col--qty';
      colQty.setAttribute('role', 'cell');
      colQty.setAttribute('data-label', str(i18n.column_quantity));
      if (inStock) {
        tpl = qtyTemplates[variantId];
        if (tpl && tpl.content) {
          colQty.appendChild(tpl.content.cloneNode(true));
        } else {
          colQty.textContent = '1';
          colQty.setAttribute('aria-label', str(i18n.column_quantity) + ': 1');
        }
      } else {
        colQty.textContent = '—';
        colQty.setAttribute('aria-label', str(i18n.column_quantity) + ': ' + str(i18n.stock_out_of_stock));
      }
      grid.appendChild(colQty);

      colAction = document.createElement('div');
      colAction.className = 'buy-again-order-items__grid-col buy-again-order-items__grid-col--action';
      colAction.setAttribute('role', 'cell');
      if (inStock) {
        colAction.setAttribute('data-label', str(i18n.column_add));
        lineBtn = document.createElement('button');
        lineBtn.type = 'button';
        lineBtn.className = 'button button--primary buy-again-order-items__line-atc';
        lineBtn.setAttribute('data-most-ordered-line-atc', '');
        lineBtn.setAttribute('data-variant-id', variantId);
        lineBtn.setAttribute('data-product-title', productTitle);
        lineBtn.setAttribute(
          'aria-label',
          replacePlaceholder(i18n.line_add_aria, '__PRODUCT__', productTitle)
        );
        appendLabelAndSpinner(lineBtn, i18n.line_add_to_cart);
        colAction.appendChild(lineBtn);
      } else {
        colAction.setAttribute('data-label', str(i18n.column_add));
        colAction.classList.add('buy-again-order-items__grid-col--action--unavailable');
        colAction.setAttribute(
          'aria-label',
          str(i18n.column_add) + ': ' + str(i18n.stock_out_of_stock)
        );
        var unavailable = document.createElement('p');
        unavailable.className = 'buy-again-order-items__line-unavailable caption';
        unavailable.setAttribute('aria-hidden', 'true');
        unavailable.textContent = str(i18n.stock_out_of_stock);
        colAction.appendChild(unavailable);
      }
      grid.appendChild(colAction);

      row.appendChild(grid);
      frag.appendChild(row);
    }

    body.appendChild(frag);
    table.appendChild(body);
    mount.appendChild(table);
  }

  function getCartAddErrorMessage(section, i18n, productTitle) {
    return (
      replacePlaceholder(i18n.cart_add_error, '__PRODUCT__', productTitle) ||
      str(section.getAttribute('data-cart-error')) ||
      str(i18n.cart_add_error_generic)
    );
  }

  function executeCartAdd(btn, section, variantId, cartLine, productTitle, i18n) {
    if (!btn || !cartLine) return;
    var row = btn.closest('[data-most-ordered-row]');
    var qty = readQtyFromRow(row);
    var line = cloneLineWithQuantity(cartLine, qty);
    var fd = buildFormData([line]);
    var cart = getCartUi();

    if (cart && typeof cart.getSectionsToRender === 'function') {
      fd.append(
        'sections',
        cart.getSectionsToRender().map(function (s) {
          return s.id;
        })
      );
      fd.append('sections_url', window.location.pathname);
    }

    setButtonLoading(btn, true);

    fetch(str(window.routes.cart_add_url), {
      method: 'POST',
      headers: { 'X-Requested-With': 'XMLHttpRequest', Accept: 'application/javascript' },
      body: fd,
    })
      .then(function (response) {
        return response.json();
      })
      .then(function (data) {
        if (data.status || data.errors) {
          var msg =
            (typeof data.description === 'string' && data.description) ||
            (Array.isArray(data.errors) && data.errors.join(', ')) ||
            getCartAddErrorMessage(section, i18n, productTitle);
          flashLiveRegion(section, msg, 7000, true);
          return;
        }

        flashLiveRegion(
          section,
          replacePlaceholder(i18n.cart_add_success, '__PRODUCT__', productTitle),
          5000,
          false
        );

        var cartData = normalizeCartAddResponse(data);

        if (cart && typeof cart.renderContents === 'function') {
          try {
            cart.renderContents(cartData);
          } catch (renderErr) {
            console.error('most-ordered cart renderContents failed:', renderErr);
          }
        }

        if (typeof publish === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
          publish(PUB_SUB_EVENTS.cartUpdate, { source: 'most-ordered-items-atc', cartData: cartData });
        }
      })
      .catch(function () {
        flashLiveRegion(section, getCartAddErrorMessage(section, i18n, productTitle), 7000, true);
      })
      .finally(function () {
        setButtonLoading(btn, false);
      });
  }

  function onSectionClick(e) {
    var btn = e.target.closest('[data-most-ordered-line-atc]');
    if (!btn || btn.disabled) return;
    var section = btn.closest('[data-most-ordered-section]');
    if (!section || !section._moiCartByVariant) return;
    var variantId = str(btn.getAttribute('data-variant-id')).trim();
    if (!variantId) return;
    var cartLine = section._moiCartByVariant[variantId];
    if (!cartLine) return;
    var i18n = section._moiI18n || {};
    executeCartAdd(btn, section, variantId, cartLine, str(btn.getAttribute('data-product-title')), i18n);
  }

  function readOrdersPages(section) {
    var mount = section.querySelector('[data-most-ordered-mount]');
    var n = parseInt(mount && mount.getAttribute('data-orders-pages'), 10);
    if (isNaN(n) || n < 1) return 1;
    return n;
  }

  function extractSectionMarkup(responseText, sectionId) {
    if (!responseText) return '';
    try {
      var payload = JSON.parse(responseText);
      if (payload && typeof payload[sectionId] === 'string') {
        return payload[sectionId];
      }
    } catch (err) {
      // Section Rendering API may return full-page HTML in some contexts.
    }
    return responseText;
  }

  function mergeQtyBankFromDoc(section, doc) {
    var bank = section.querySelector('[data-most-ordered-qty-bank]');
    if (!bank) return;

    var incoming = doc.querySelector('[data-most-ordered-qty-bank]');
    if (!incoming) return;

    var existing = buildQtyTemplateMap(bank);
    var slots = incoming.querySelectorAll('template[data-most-ordered-qty-slot]');
    var i;
    var tpl;
    var vid;

    for (i = 0; i < slots.length; i++) {
      tpl = slots[i];
      vid = str(tpl.getAttribute('data-variant-id')).trim();
      if (!vid || existing[vid]) continue;
      bank.appendChild(tpl.cloneNode(true));
      existing[vid] = tpl;
    }
  }

  function fetchOrderEntriesPage(section, pageNum) {
    var sectionId = str(section.getAttribute('data-section-id')).trim();
    if (!sectionId) return Promise.resolve([]);
    var url = new URL(window.location.pathname, window.location.origin);
    url.searchParams.set('section_id', sectionId);
    url.searchParams.set('page', String(pageNum));
    return fetch(url.toString(), {
      headers: { 'X-Requested-With': 'XMLHttpRequest' },
    })
      .then(function (response) {
        return response.text();
      })
      .then(function (responseText) {
        var markup = extractSectionMarkup(responseText, sectionId);
        var doc = new DOMParser().parseFromString(markup, 'text/html');
        mergeQtyBankFromDoc(section, doc);
        var entries = parseJsonEl(doc.querySelector('[data-most-ordered-entries]'), []);
        return Array.isArray(entries) ? entries : [];
      })
      .catch(function () {
        return [];
      });
  }

  function readUrlPageParam() {
    var page = new URL(window.location.href).searchParams.get('page');
    var n = parseInt(page, 10);
    if (isNaN(n) || n < 1) return 1;
    return n;
  }

  function loadAllOrderEntries(section, initialEntries) {
    var totalPages = readOrdersPages(section);
    var urlPage = readUrlPageParam();
    var entries = [];
    var pagePromises = [];
    var p;

    if (totalPages <= 1) {
      return Promise.resolve(Array.isArray(initialEntries) ? initialEntries.slice() : []);
    }

    if (urlPage === 1) {
      entries = Array.isArray(initialEntries) ? initialEntries.slice() : [];
      for (p = 2; p <= totalPages; p++) {
        pagePromises.push(fetchOrderEntriesPage(section, p));
      }
    } else {
      for (p = 1; p <= totalPages; p++) {
        if (p === urlPage) {
          entries = entries.concat(Array.isArray(initialEntries) ? initialEntries : []);
        } else {
          pagePromises.push(fetchOrderEntriesPage(section, p));
        }
      }
    }

    return Promise.all(pagePromises).then(function (pageResults) {
      var i;
      for (i = 0; i < pageResults.length; i++) {
        entries = entries.concat(pageResults[i]);
      }
      return entries;
    });
  }

  function mountMostOrderedSection(section) {
    var mount = section.querySelector('[data-most-ordered-mount]');
    if (!mount) return;

    var dataEl = section.querySelector('[data-most-ordered-entries]');
    var i18nEl = section.querySelector('[data-most-ordered-i18n]');
    var entries = parseJsonEl(dataEl, []);
    if (!Array.isArray(entries)) entries = [];
    var i18n = parseJsonEl(i18nEl, {});
    section._moiI18n = i18n;

    if (!section._moiClickBound) {
      section.addEventListener('click', onSectionClick);
      section._moiClickBound = true;
    }

    loadAllOrderEntries(section, entries).then(function (allEntries) {
      var items = aggregateTopItems(allEntries, readItemsToShow(section));
      renderList(section, items, i18n);
    });
  }

  function initMostOrderedMount() {
    var sections = document.querySelectorAll('[data-most-ordered-section]');
    var si;

    for (si = 0; si < sections.length; si++) {
      mountMostOrderedSection(sections[si]);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initMostOrderedMount, { once: true });
  } else {
    initMostOrderedMount();
  }
})();
